// Global cache to track which images have been successfully loaded
const globalLoadedImageCache = new Set<string>();

// Event system for cache updates
const cacheUpdateListeners = new Set<() => void>();

const notifyCacheUpdate = () => {
  cacheUpdateListeners.forEach(listener => listener());
};

export const addCacheUpdateListener = (listener: () => void) => {
  cacheUpdateListeners.add(listener);
  return () => {
    cacheUpdateListeners.delete(listener);
  };
};

export const isImageAlreadyLoaded = (imageSrc: string): boolean => {
  return globalLoadedImageCache.has(imageSrc);
};

export const markImageAsLoaded = (imageSrc: string): void => {
  globalLoadedImageCache.add(imageSrc);
  notifyCacheUpdate();
};
